import { render, staticRenderFns } from "./zhuanzhong.vue?vue&type=template&id=019f4c6a&scoped=true&"
import script from "./zhuanzhong.vue?vue&type=script&lang=js&"
export * from "./zhuanzhong.vue?vue&type=script&lang=js&"
import style0 from "./zhuanzhong.vue?vue&type=style&index=0&id=019f4c6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f4c6a",
  null
  
)

export default component.exports